const queryKeys = {
  SUPPLIER_BRANCH: 'supplier-branch',
  SUPPLIERS: 'suppliers',
  SUPPLIER_USERS: 'supplier-users',
  SUPPLIER_ADDRESS: 'supplier-address',
}

export default queryKeys
